module.exports = __webpack_public_path__ + "static/img/Ethan-Sanders.5e7a46f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ethan-Sanders.jpg
// module id = LtN6
// module chunks = 0